import { actionShowModal, actionHideModal } from 'react-redux-app/lib/modules/modal/actions';

import { MODAL_DIALOG__CHANGE_PASSWORD } from '../../constants/dialogs';


export const actionShowChangePasswordDialog = () => dispatch => (
  dispatch(actionShowModal(MODAL_DIALOG__CHANGE_PASSWORD))
);

export const actionHideChangePasswordDialog = () => dispatch => (
  dispatch(actionHideModal(MODAL_DIALOG__CHANGE_PASSWORD))
);
